module.exports = __webpack_public_path__ + "5d184f759e252c617fe44fdb96466e1d.png";